import type { OptionalCapability } from "./capabilities";

/**
 * Terminal: a call was retried with a freshly-minted token and still came
 * back 401. Not retryable — the UI should tell the user to reopen the editor
 * rather than offering "try again".
 */
export class SessionExpiredError extends Error {
  constructor() {
    super("Session expired — please reopen the editor.");
    this.name = "SessionExpiredError";
  }
}

/**
 * The request needs a backend endpoint group that has not shipped (or was
 * demoted after a 404/501 proved the allow-list optimistic). Thrown BEFORE
 * any network traffic when the flag is off.
 */
export class CapabilityUnavailableError extends Error {
  constructor(public capability: OptionalCapability) {
    super(
      `The "${capability}" capability is not available in this environment — ` +
        `its backend endpoint has not shipped. See TEMPLATE_EDITOR_API_CONTRACT_REQUEST.md.`,
    );
    this.name = "CapabilityUnavailableError";
  }
}
